var map = {
	"./ac.svg": 87675,
	"./ad.svg": 77908,
	"./ae.svg": 34165,
	"./af-emirate.svg": 33944,
	"./af.svg": 62294,
	"./afar.svg": 11171,
	"./ag.svg": 26119,
	"./ai.svg": 73185,
	"./al.svg": 24508,
	"./am.svg": 13981,
	"./an.svg": 59806,
	"./ao.svg": 3535,
	"./aq-true_south.svg": 59588,
	"./aq.svg": 46505,
	"./ar.svg": 78394,
	"./as.svg": 93003,
	"./at.svg": 88324,
	"./au-aboriginal.svg": 20262,
	"./au-act.svg": 99046,
	"./au-nsw.svg": 17270,
	"./au-nt.svg": 828,
	"./au-qld.svg": 12687,
	"./au-sa.svg": 30510,
	"./au-tas.svg": 21830,
	"./au-vic.svg": 25040,
	"./au-wa.svg": 22890,
	"./au.svg": 39493,
	"./aw.svg": 31447,
	"./ax.svg": 79264,
	"./az.svg": 94850,
	"./ba.svg": 33872,
	"./bb.svg": 95363,
	"./bd.svg": 91357,
	"./be.svg": 20732,
	"./bf.svg": 99759,
	"./bg.svg": 37182,
	"./bh.svg": 14905,
	"./bi.svg": 6984,
	"./bj.svg": 88347,
	"./bl.svg": 80917,
	"./bm.svg": 38932,
	"./bn.svg": 26791,
	"./bo.svg": 23318,
	"./bq-bo.svg": 50304,
	"./bq-sa.svg": 26309,
	"./bq-se.svg": 16969,
	"./bq.svg": 99168,
	"./br.svg": 70067,
	"./bs.svg": 91074,
	"./bt.svg": 65741,
	"./bv.svg": 41375,
	"./bw.svg": 36622,
	"./by.svg": 38488,
	"./bz.svg": 93675,
	"./ca-bc.svg": 85997,
	"./ca-qc.svg": 46208,
	"./ca.svg": 33703,
	"./cc.svg": 7125,
	"./cd.svg": 51850,
	"./cf.svg": 96104,
	"./cg.svg": 77849,
	"./ch-gr.svg": 46004,
	"./ch.svg": 91678,
	"./ci.svg": 70607,
	"./ck.svg": 20125,
	"./cl.svg": 69842,
	"./cm.svg": 19235,
	"./cn-hk.svg": 29278,
	"./cn-xj.svg": 43935,
	"./cn.svg": 53136,
	"./co.svg": 51585,
	"./cp.svg": 76230,
	"./cq.svg": 39031,
	"./cr.svg": 34436,
	"./cu.svg": 99147,
	"./cv.svg": 43960,
	"./cw.svg": 19465,
	"./cx.svg": 8910,
	"./cy.svg": 46847,
	"./cz.svg": 67820,
	"./de.svg": 85746,
	"./dg.svg": 99664,
	"./dj.svg": 53653,
	"./dk.svg": 32020,
	"./dm.svg": 24554,
	"./do.svg": 77832,
	"./dz.svg": 70885,
	"./ea.svg": 14125,
	"./earth.svg": 25985,
	"./east_african_federation.svg": 88899,
	"./easter_island.svg": 11487,
	"./ec-w.svg": 92503,
	"./ec.svg": 45791,
	"./ee.svg": 42705,
	"./eg.svg": 89331,
	"./eh.svg": 26052,
	"./er.svg": 25822,
	"./es-ar.svg": 84473,
	"./es-ce.svg": 57372,
	"./es-cn.svg": 99495,
	"./es-ct.svg": 85421,
	"./es-ga.svg": 45396,
	"./es-ib.svg": 23489,
	"./es-ml.svg": 42275,
	"./es-pv.svg": 93046,
	"./es-variant.svg": 62019,
	"./es.svg": 45871,
	"./et-or.svg": 40602,
	"./et-ti.svg": 85312,
	"./et.svg": 52080,
	"./eu.svg": 43201,
	"./european_union.svg": 60908,
	"./ewe.svg": 69924,
	"./fi.svg": 14844,
	"./fj.svg": 93871,
	"./fk.svg": 50142,
	"./fm.svg": 27984,
	"./fo.svg": 70386,
	"./fr-20r.svg": 96112,
	"./fr-bre.svg": 4137,
	"./fr-cp.svg": 23321,
	"./fr.svg": 21783,
	"./fx.svg": 55405,
	"./ga.svg": 35755,
	"./gb-con.svg": 61895,
	"./gb-eng.svg": 4815,
	"./gb-nir.svg": 40884,
	"./gb-ork.svg": 4437,
	"./gb-sct.svg": 13009,
	"./gb-wls.svg": 50759,
	"./gb.svg": 85016,
	"./gd.svg": 59814,
	"./ge-ab.svg": 57489,
	"./ge.svg": 74199,
	"./gf.svg": 31076,
	"./gg.svg": 82245,
	"./gh.svg": 37602,
	"./gi.svg": 42771,
	"./gl.svg": 59470,
	"./gm.svg": 87903,
	"./gn.svg": 8876,
	"./gp.svg": 70058,
	"./gq.svg": 30427,
	"./gr.svg": 79688,
	"./gs.svg": 61433,
	"./gt.svg": 5046,
	"./gu.svg": 68871,
	"./guarani.svg": 59284,
	"./gw.svg": 76917,
	"./gy.svg": 37443,
	"./hausa.svg": 19527,
	"./hk.svg": 46600,
	"./hm.svg": 71958,
	"./hmong.svg": 22012,
	"./hn.svg": 43829,
	"./hr.svg": 24881,
	"./ht.svg": 54815,
	"./hu.svg": 26382,
	"./ic.svg": 62099,
	"./id-jb.svg": 74745,
	"./id-jt.svg": 35927,
	"./id.svg": 28204,
	"./ie.svg": 27149,
	"./il.svg": 50404,
	"./im.svg": 1573,
	"./in-as.svg": 30151,
	"./in-gj.svg": 65092,
	"./in-ka.svg": 65803,
	"./in-mn.svg": 31934,
	"./in-mz.svg": 34242,
	"./in-or.svg": 3012,
	"./in-tg.svg": 97356,
	"./in-tn.svg": 37541,
	"./in.svg": 79142,
	"./io.svg": 93527,
	"./iq-kr.svg": 18897,
	"./iq.svg": 35265,
	"./ir.svg": 42130,
	"./is.svg": 56771,
	"./it-21.svg": 29106,
	"./it-23.svg": 86704,
	"./it-25.svg": 8862,
	"./it-32.svg": 39490,
	"./it-34.svg": 20652,
	"./it-36.svg": 85038,
	"./it-42.svg": 90015,
	"./it-45.svg": 72544,
	"./it-52.svg": 48720,
	"./it-55.svg": 42511,
	"./it-57.svg": 68733,
	"./it-62.svg": 3957,
	"./it-65.svg": 93546,
	"./it-67.svg": 30024,
	"./it-72.svg": 15622,
	"./it-75.svg": 58857,
	"./it-77.svg": 22187,
	"./it-78.svg": 7212,
	"./it-82.svg": 77507,
	"./it-88.svg": 80697,
	"./it.svg": 86588,
	"./je.svg": 71860,
	"./jm.svg": 1244,
	"./jo.svg": 1342,
	"./jp.svg": 29129,
	"./kanuri.svg": 88035,
	"./ke.svg": 86643,
	"./kg.svg": 36465,
	"./kh.svg": 38310,
	"./ki.svg": 1111,
	"./kikuyu.svg": 39681,
	"./km.svg": 61227,
	"./kn.svg": 6040,
	"./kongo.svg": 6783,
	"./kp.svg": 53758,
	"./kr.svg": 53660,
	"./kw.svg": 13665,
	"./ky.svg": 95783,
	"./kz.svg": 24276,
	"./la.svg": 80566,
	"./lb.svg": 38165,
	"./lc.svg": 96180,
	"./li.svg": 94430,
	"./lk.svg": 77980,
	"./lr.svg": 43493,
	"./ls.svg": 88772,
	"./lt.svg": 50923,
	"./lu.svg": 31866,
	"./lv.svg": 46953,
	"./ly.svg": 93870,
	"./ma.svg": 95909,
	"./malayali.svg": 4407,
	"./maori.svg": 77196,
	"./mars.svg": 95972,
	"./mc.svg": 67959,
	"./md.svg": 48152,
	"./me.svg": 99369,
	"./mf.svg": 84282,
	"./mg.svg": 3339,
	"./mh.svg": 95692,
	"./mk.svg": 51039,
	"./ml.svg": 8832,
	"./mm.svg": 55281,
	"./mn.svg": 738,
	"./mo.svg": 79731,
	"./mp.svg": 48596,
	"./mq-old.svg": 1945,
	"./mq.svg": 90581,
	"./mr.svg": 32982,
	"./ms.svg": 36455,
	"./mt.svg": 16648,
	"./mu.svg": 24569,
	"./mv.svg": 63818,
	"./mw.svg": 98011,
	"./mx.svg": 30396,
	"./my.svg": 1021,
	"./mz.svg": 46846,
	"./na.svg": 18540,
	"./nato.svg": 84895,
	"./nc.svg": 69134,
	"./ne.svg": 31680,
	"./nf.svg": 52435,
	"./ng.svg": 47266,
	"./ni.svg": 40740,
	"./nl-fr.svg": 35590,
	"./nl.svg": 98921,
	"./no.svg": 30810,
	"./northern_cyprus.svg": 86710,
	"./np.svg": 66397,
	"./nr.svg": 55951,
	"./nu.svg": 90064,
	"./nz.svg": 78535,
	"./occitania.svg": 39356,
	"./olympics.svg": 94295,
	"./om.svg": 89895,
	"./otomi.svg": 56815,
	"./pa.svg": 34826,
	"./pe.svg": 20342,
	"./pf.svg": 61589,
	"./pg.svg": 19604,
	"./ph.svg": 76035,
	"./pk-jk.svg": 45460,
	"./pk-sd.svg": 11176,
	"./pk.svg": 14544,
	"./pl.svg": 80431,
	"./pm.svg": 17854,
	"./pn.svg": 72029,
	"./pr.svg": 70377,
	"./ps.svg": 19160,
	"./pt-20.svg": 94078,
	"./pt-30.svg": 69449,
	"./pt.svg": 38967,
	"./pw.svg": 12196,
	"./py.svg": 71746,
	"./qa.svg": 22793,
	"./quechua.svg": 62705,
	"./re.svg": 41964,
	"./ro.svg": 92902,
	"./rs.svg": 55890,
	"./ru-ba.svg": 30386,
	"./ru-ce.svg": 91117,
	"./ru-cu.svg": 16733,
	"./ru-da.svg": 1740,
	"./ru-dpr.svg": 2037,
	"./ru-ko.svg": 63055,
	"./ru-lpr.svg": 75149,
	"./ru-ta.svg": 3868,
	"./ru-ud.svg": 27534,
	"./ru.svg": 348,
	"./rw.svg": 35646,
	"./sa.svg": 61175,
	"./sami.svg": 91449,
	"./sb.svg": 6724,
	"./sc.svg": 3973,
	"./sd.svg": 80442,
	"./se.svg": 74315,
	"./sg.svg": 41609,
	"./sh-ac.svg": 1951,
	"./sh-hl.svg": 60355,
	"./sh-ta.svg": 19274,
	"./sh.svg": 11822,
	"./si.svg": 26463,
	"./sj.svg": 47436,
	"./sk.svg": 94797,
	"./sl.svg": 66274,
	"./sm.svg": 70003,
	"./sn.svg": 8992,
	"./so.svg": 23377,
	"./somaliland.svg": 21089,
	"./south_ossetia.svg": 30935,
	"./soviet_union.svg": 77953,
	"./sr.svg": 65108,
	"./ss.svg": 86741,
	"./st.svg": 57642,
	"./su.svg": 26459,
	"./sv.svg": 10920,
	"./sx.svg": 6494,
	"./sy.svg": 26543,
	"./sz.svg": 24220,
	"./ta.svg": 84750,
	"./tc.svg": 43660,
	"./td.svg": 403,
	"./tf.svg": 50225,
	"./tg.svg": 9664,
	"./th.svg": 14871,
	"./tibet.svg": 61123,
	"./tj.svg": 88293,
	"./tk.svg": 10276,
	"./tl.svg": 74987,
	"./tm.svg": 69722,
	"./tn.svg": 95305,
	"./to.svg": 19800,
	"./torres_strait_islands.svg": 63182,
	"./tr.svg": 95965,
	"./transnistria.svg": 67891,
	"./tt.svg": 95075,
	"./tv.svg": 27425,
	"./tw.svg": 28976,
	"./tz.svg": 82965,
	"./ua.svg": 37405,
	"./ug.svg": 18115,
	"./uk.svg": 49543,
	"./um.svg": 42105,
	"./un.svg": 50730,
	"./united_nations.svg": 4163,
	"./us-ak.svg": 60656,
	"./us-al.svg": 70799,
	"./us-ar.svg": 69513,
	"./us-az.svg": 67633,
	"./us-ca.svg": 6336,
	"./us-co.svg": 48742,
	"./us-dc.svg": 74351,
	"./us-fl.svg": 88510,
	"./us-ga.svg": 77380,
	"./us-hi.svg": 85561,
	"./us-in.svg": 93957,
	"./us-mo.svg": 47232,
	"./us-ms.svg": 75604,
	"./us-nc.svg": 75377,
	"./us-nm.svg": 88055,
	"./us-ri.svg": 44015,
	"./us-tn.svg": 17818,
	"./us-tx.svg": 980,
	"./us.svg": 68575,
	"./uy.svg": 62917,
	"./uz.svg": 40486,
	"./va.svg": 54948,
	"./vc.svg": 10534,
	"./ve.svg": 61912,
	"./vg.svg": 98042,
	"./vi.svg": 9452,
	"./vn.svg": 93491,
	"./vu.svg": 30408,
	"./wf.svg": 85620,
	"./wiphala.svg": 65941,
	"./ws.svg": 42889,
	"./xk.svg": 81240,
	"./xx.svg": 31099,
	"./ye.svg": 62877,
	"./yorubaland.svg": 43044,
	"./yt.svg": 10572,
	"./yu.svg": 62381,
	"./za.svg": 25912,
	"./zm.svg": 57100,
	"./zw.svg": 76118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27867;